import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import {
  createLeadSourceTag,
  createLeadSourceTagFailure,
  createLeadSourceTagSuccess,
} from '../actions/create-lead-source-tag.actions';
import { LeadSourceTagsApiService } from '@core/services/lead-source-tags-api.service';
import { ToastService } from '@shared/services/toast.service';

@Injectable()
export class CreateLeadSourceTagEffects {
  constructor(
    private actions$: Actions,
    private leadSourceTagsApiService: LeadSourceTagsApiService,
    private toastService: ToastService,
  ) {}

  createLeadSourceTag$ = createEffect(() =>
    this.actions$.pipe(
      ofType(createLeadSourceTag),
      switchMap((action) =>
        this.leadSourceTagsApiService.create(action.leadSourceTag).pipe(
          map((response) => createLeadSourceTagSuccess({ leadSourceTag: response.data })),
          catchError((error) => of(createLeadSourceTagFailure({ error }))),
        ),
      ),
    ),
  );

  createLeadSourceTagSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createLeadSourceTagSuccess),
        tap(({ leadSourceTag }) => {
          this.toastService.showToast(
            'success',
            `Successfully created source tag "${leadSourceTag.attributes.name}".`,
            3000,
          );
        }),
      ),
    { dispatch: false },
  );

  createLeadSourceTagFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(createLeadSourceTagFailure),
        tap(() => {
          this.toastService.showToast(
            'error',
            'Failed to create lead source tag. Please check for duplicates and try again.',
          );
        }),
      ),
    { dispatch: false },
  );
}
